import React from 'react';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import Battery90Icon from '@mui/icons-material/Battery90';
import Battery80Icon from '@mui/icons-material/Battery80';
import Battery60Icon from '@mui/icons-material/Battery60';
import Battery50Icon from '@mui/icons-material/Battery50';
import Battery30Icon from '@mui/icons-material/Battery30';
import Battery20Icon from '@mui/icons-material/Battery20';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/system';

const IconWrapper = styled('div')({
  position: 'relative',
  display: 'inline-block',
});

const BatteryEmptyIcon = styled(BatteryFullIcon)({
  fill: '#c2c2c2'
});

const BatteryIcon = ({ batteryVoltage }) => {
  // Convert battery voltage to percentage
  // Sensors stop at 3.55V (minimum), 4.1V is considered full
  const minVoltage = 3.55; // Sensors stop sending data at this voltage
  const maxVoltage = 4.1;  // Practical full charge
  const batteryPerc = Math.round(
    Math.max(0, Math.min(100, ((batteryVoltage - minVoltage) / (maxVoltage - minVoltage)) * 100))
  );
  
  // Determine color based on battery percentage
  const getColor = () => {
    if (batteryPerc > 60) return '#16a34a'; // Green - healthy range
    if (batteryPerc > 40) return '#65a30d'; // Light green
    if (batteryPerc > 20) return '#f59e0b'; // Orange - warning
    if (batteryPerc > 5) return '#dc2626'; // Red - critical
    return '#991b1b'; // Dark red - sensors about to stop
  };
  
  const color = getColor();
  
  return (
    <Tooltip 
      title={`${batteryPerc}% (${batteryVoltage}V)`} 
      componentsProps={{ tooltip: { sx: { background: '#000' } } }} 
      placement="top"
    >
      <IconWrapper>
        {batteryPerc === 100 && <BatteryFullIcon sx={{ color }} />}
        {batteryPerc < 100 && batteryPerc >= 90 && <Battery90Icon sx={{ color }} />}
        {batteryPerc < 90 && batteryPerc >= 80 && <Battery80Icon sx={{ color }} />}
        {batteryPerc < 80 && batteryPerc >= 60 && <Battery60Icon sx={{ color }} />}
        {batteryPerc < 60 && batteryPerc >= 50 && <Battery50Icon sx={{ color }} />}
        {batteryPerc < 50 && batteryPerc >= 30 && <Battery30Icon sx={{ color }} />}
        {batteryPerc < 30 && batteryPerc > 0 && <Battery20Icon sx={{ color }} />}
        {batteryPerc === 0 && <BatteryEmptyIcon />}
      </IconWrapper>
    </Tooltip>
  );
};

export default BatteryIcon;